import { useRef, useEffect } from 'react';
import posthog from 'posthog-js';

function useSectionView(eventName) {
  const ref = useRef(null);
  const fired = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !fired.current) {
          fired.current = true;
          posthog.capture(eventName);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [eventName]);

  return ref;
}

export default useSectionView;
